import { useState, useCallback } from 'react';

interface InsertZoneProps {
  onInsert: () => void;
  /** Label text shown in the button (default: "Add section") */
  label?: string;
  /** Gap height in pixels (default: 16) */
  gap?: number;
}

const DEFAULT_GAP = 16; // Must match Section marginBottom

export function InsertZone({ onInsert, label = 'Add section', gap = DEFAULT_GAP }: InsertZoneProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = useCallback(() => {
    setIsHovered(false); // Hide immediately on click
    onInsert();
  }, [onInsert]);

  return (
    <div
      style={{
        position: 'relative',
        height: 0,
        overflow: 'visible',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -gap,
          left: 0,
          right: 0,
          height: gap,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          onClick={handleClick}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: '1px 8px',
            fontSize: '11px',
            color: 'var(--text-muted, #94a3b8)',
            backgroundColor: isHovered ? 'var(--bg-base, #fff)' : 'transparent',
            border: isHovered ? '1px dashed var(--border-default, #e2e8f0)' : '1px dashed transparent',
            borderRadius: '3px',
            cursor: 'pointer',
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 150ms ease, background-color 150ms ease, border-color 150ms ease',
          }}
        >
          <span style={{ fontSize: '12px', fontWeight: 500, lineHeight: 1 }}>+</span>
          <span>{label}</span>
        </button>
      </div>
    </div>
  );
}
